import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { TInitialState } from '~/src/components/ConnectDomruPopup/context/initialState';

export const getResultStatus = (state: TInitialState): EResultPopupStatus => state.result.status;
